import { BookmarkedRecipesCollectionRef } from 'services/firebase';
import RecipeMapper from 'services/mappers/recipes/RecipeMapper';

const onBookmarkedRecipes = (userID, onRecipesReceived) => {
  if (!userID) throw new Error('userID cannot be empty');

  const unsubscribe = BookmarkedRecipesCollectionRef()
    .where('userID', '==', userID)
    .where('bookmarked', '==', true)
    .onSnapshot((snapshot) => {
      const recipes = [];

      snapshot.forEach((doc) => {
        const data = doc.data();

        const recipeID = data.recipeID;

        recipes.push(
          RecipeMapper.mapFirebaseRefToModel(recipeID, {
            content: data.content,
            createdAt: data.createdAt,
          })
        );
      });

      onRecipesReceived(recipes);
    });

  return unsubscribe;
};

export default onBookmarkedRecipes;
